import { render, staticRenderFns } from "./BasicTextBlock.vue?vue&type=template&id=a4d30536"
import script from "./BasicTextBlock.vue?vue&type=script&lang=js"
export * from "./BasicTextBlock.vue?vue&type=script&lang=js"
import style0 from "./BasicTextBlock.vue?vue&type=style&index=0&id=a4d30536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports